export class IcebergSinkProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retention",
            "baseName": "retention",
            "type": "TableRetentionConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IcebergSinkProperties.attributeTypeMap;
    }
    constructor() {
    }
}
